import { render } from "./StackedSideBar.vue?vue&type=template&id=9dd6429e&scoped=true"
import script from "./StackedSideBar.vue?vue&type=script&lang=js"
export * from "./StackedSideBar.vue?vue&type=script&lang=js"

import "./StackedSideBar.vue?vue&type=style&index=0&id=9dd6429e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9dd6429e"

export default script